import { serverApi } from '../utils/request'

class LocationService {
  public async getById(id: any) {
    return await serverApi.get(`/api/v1/geolocation/locations/${id}`)
  }

  public async getByUserId(userId: any) {
    return await serverApi.get(`/api/v1/geolocation/locations/doGetByUserId/${userId}`)
  }

  public async saveLocation(data: any) {
    return await serverApi.post('/api/v1/geolocation/locations/doInsertByPlaceId', data)
  }

  public async update(data: any) {
    return await serverApi.post('/api/v1/geolocation/locations', data)
  }

  public async search(input: string) {
    return await serverApi.post(`/api/v1/geolocation/locations/doGetPlacePredictions`, {
      input
    })
  }
}

const locationService = new LocationService()
export { locationService }



// WEBPACK FOOTER //
// ./src/services/Location.ts